import { render } from "./AboutRoots.vue?vue&type=template&id=51fc582a&scoped=true"
import script from "./AboutRoots.vue?vue&type=script&lang=js"
export * from "./AboutRoots.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\sthem\\source\\repos\\Insync\\Pamodzi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51fc582a"]])

export default __exports__